// extracted by mini-css-extract-plugin
export default {"list_item":"styles_list_item__19Vay","list_item__linked":"styles_list_item__linked__25HBz","list_item__bold":"styles_list_item__bold__P9vzB"};